import { hasAuthorizedPoisAcrossProfiles, useGetPaymentProfiles } from 'dashboard-experience/shared/hooks'
import { useExperiment } from 'shared/experiment'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

import { useIsOneStone } from './use-is-one-stone'

export function useIsAffiliationsEnabled() {
  const isOneStone = useIsOneStone()
  const { deusExMachina } = useDeusExMachina()
  const subjectId = deusExMachina?.subject?.id ?? ''
  const stoneAccountId = deusExMachina?.entity?.stoneAccount?.id ?? ''
  const { data: paymentProfiles, isLoading: isProfilesLoading } = useGetPaymentProfiles({ stoneAccountId })
  const hasEcommercePoi = hasAuthorizedPoisAcrossProfiles(paymentProfiles, ['ecommerce'])
  const hasExternalProvidersEnabled = Boolean(paymentProfiles?.some(profile => profile.externalProvidersEnabled))
  const { isFeatureFlagEnabled, isLoading, ...rest } = useExperiment(
    subjectId,
    'vc_digital_settings_enable_affiliations_web'
  )

  return {
    isFeatureFlagEnabled: isFeatureFlagEnabled && isOneStone && hasEcommercePoi && hasExternalProvidersEnabled,
    isLoading: isLoading || isProfilesLoading,
    ...rest
  }
}
